import { render, staticRenderFns } from "./mailer.vue?vue&type=template&id=15c41dc3&scoped=true&"
import script from "./mailer.vue?vue&type=script&lang=js&"
export * from "./mailer.vue?vue&type=script&lang=js&"
import style0 from "./mailer.vue?vue&type=style&index=0&id=15c41dc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c41dc3",
  null
  
)

export default component.exports